// Keep names stable; import these constants rather than using string literals.

export const SIX_PASSKEY_ID = 'six_passkey_id'
export const SIX_PASSKEY_OWNER = 'six_passkey_owner_user_id'
export const SIX_PASSKEY_SETUP_SKIPPED = 'six_passkey_setup_skipped'

export const SIX_DEVICE_AUTH_VERIFIED = 'six_device_auth_verified'
export const SIX_DEVICE_AUTH_ATTEMPTED = 'six_device_auth_attempted'
export const SIX_DEVICE_AUTH_LAST_ACTIVITY_TS = 'six_device_auth_last_activity_ts'
export const SIX_PENDING_SIGNUP_TERMS_VERSION_ID = 'six_pending_signup_terms_version_id'

// Per-session timestamp guard key to avoid re-applying updates too frequently
export const SIX_UPDATE_APPLIED_AT = 'six_update_applied_at'

// Generic prefixes used by cleanup code
export const SIX_LOCAL_PREFIX = 'six-'
export const SIX_SESSION_PREFIX = 'six_'
